import React, { useContext, useState, useEffect } from "react";
import "./StartupProjects.scss";
import { bigProjects } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function StartupProject() {
  const { isDark } = useContext(StyleContext);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    if (bigProjects.projects.length > 0) {
      setSelectedProject(0);
      //setTimeout(scrollToDetail, 100);
    }
  }, []);

  // Add scroll to detail function
  const scrollToDetail = () => {
    const detailElement = document.getElementById('project-detail');
    if (detailElement) {
      detailElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

    // Add scroll to heading function
  const scrollToHeading = () => {
    const detailElement = document.getElementById('skills-heading');
    if (detailElement) {
      detailElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };

  // Modify click handler to include scroll
  const handleProjectClick = (index) => {
    setSelectedProject(index === selectedProject ? null : index);
    // Wait for state to update and DOM to render
    setTimeout(scrollToDetail, 100);
  };

  function openUrlInNewTab(url) {
    if (!url) return;
    var win = window.open(url, "_blank");
    win.focus();
  }

  if (!bigProjects.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>


          <h1 className="skills-heading" id="skills-heading">{bigProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {bigProjects.subtitle}
          </p>

          <div className="projects-container">
            {bigProjects.projects.map((project, index) => (
              <div
                key={index}
                className={`${isDark
                    ? "dark-mode project-card project-card-dark"
                    : "project-card project-card-light"
                  } ${selectedProject === index ? "selected-project" : ""}`}
                onClick={() => handleProjectClick(index)}
              >
                <div className="click-indicator">Click to view details</div>
                {project.image && (
                  <div className="project-image">
                    <img
                      src={project.image}
                      alt={project.projectName}
                      className="card-image"
                    />
                  </div>
                )}
                <div className="project-detail">
                  <h5 className={isDark ? "dark-mode card-title" : "card-title"}>
                    {project.projectName}
                  </h5>
                  {/* <p
                    className={
                      isDark ? "dark-mode card-subtitle" : "card-subtitle"
                    }
                  >
                    {project.projectDesc}
                  </p> */}
                  {/* {project.footerLink && (
                    <div className="project-card-footer">
                      {project.footerLink.map((link, i) => (
                        <span
                          key={i}
                          className={
                            isDark ? "dark-mode project-tag" : "project-tag"
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            openUrlInNewTab(link.url);
                          }}
                          style={{cursor: "pointer"}}
                        >
                          {link.name}
                        </span>
                      ))}
                    </div>
                  )} */}
                </div>
              </div>
            ))}
          </div>

          {/* Detail Container */}
          {selectedProject !== null && (
            <div className="project-detail-container">
              <div className={isDark ? "dark-mode detail-card" : "detail-card"}>

                {/* Project Title */}
                <h3 id="project-detail" style={{ textAlign: "left" }}>{bigProjects.projects[selectedProject].projectName}</h3>

                {/* Project Description */}
                <div className="detail-text">
                  <p>{bigProjects.projects[selectedProject].projectDesc}</p>
                </div>

                {/* Screenshots */}
                {bigProjects.projects[selectedProject].images && (
                  <div className="project-screenshots">
                    {bigProjects.projects[selectedProject].images.map((img, idx) => (
                      <img
                        key={idx}
                        src={img}
                        alt={`${bigProjects.projects[selectedProject].projectName} screenshot ${idx + 1}`}
                        className="detail-image"
                      />
                    ))}
                  </div>
                )}

                {/* Note
                {bigProjects.projects[selectedProject].projectId == 'agric' && (
                  <p>*Note: Some features may be limited in certain regions.</p>
                )} */}

                {/* Tech Stack */}
                {bigProjects.projects[selectedProject].techStack && (
                  <p className="tech-stack">
                    <strong>Tech Stack:</strong> {bigProjects.projects[selectedProject].techStack.join(", ")}
                  </p>
                )}

                {/* Features */}
                {bigProjects.projects[selectedProject].features && (
                  <ul className="project-features">
                    {bigProjects.projects[selectedProject].features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                )}

                {/* Footer Links */}
                {bigProjects.projects[selectedProject].footerLink && (
                  <div className="project-detail-footer">
                    {bigProjects.projects[selectedProject].footerLink.map((link, i) => (
                      <button
                        key={i}
                        onClick={() => window.open(link.url, "_blank")}
                        className={isDark ? "dark-mode project-tag" : "project-tag"}
                      >
                        {link.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}



        </div>
      </div>
    </Fade>
  );
}
